import { FontWeight, ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

export default createUseStyles(({ breakpoints }: ITheme) => ({
  '@global': {
    ':root': {
      fontSize: 16,
      '--text-heading-color': '#121212',
    },
  },
  root: {
    backgroundColor: 'var(--x-bg-5)',
  },
  resultsMsg: {
    fontSize: 16,
    fontWeight: FontWeight.SemiBold,
    lineHeight: '24px',
    color: '#949494',
  },
  breadcrumbContainer: {
    marginTop: 12,
    paddingLeft: 40,
    [mediaQuery(breakpoints.tablet)]: {
      paddingLeft: 16,
    },
  },
  notifications: {
    top: 176,
  },
}));
